<div class="content grid-1-auto md3-surface">
  <div class="content md3-card-on-surface">
    <app-exc-pdfviewer-v3 [docPath]="viewerurl"
                          [docID]="frmVData.frmVID"
                          [docName]="frmVData.frmVName"

                          [showFileUpload]="excSecurity.isFeatured('FORMVMGMT')"
                          [showFormulaToolbar]="false"
                          [canShowFormulaToolbar]="excSecurity.isFeatured('FORMVMGMT')"
                          [showAnnotationToolbar]="false"
                          [defaultFormularMode]="'fill'"
                          [suppressSignatureFieldClick]="true"

                          (fileUploaded)="receiptPDFViewer.fileUploaded($event)"

                          (viewerDocumentLoaded)="receiptPDFViewer.onDocumentLoaded()"
                          (viewerPageClicked)="receiptPDFViewer.pageClicked()"
                          (ready)="receiptPDFViewer.onViewerReady()">
    </app-exc-pdfviewer-v3>
  </div>
  <!-- Side Bar -->
  <div class="md3-card-on-surface app-height-auto app-drawer" style="overflow: visible;">
    <i class="disabled search-filter-action"></i>
    <i class="search-filter-seperator"></i>
    <i class="fal fa-save search-filter-action"
       (click)="save(false)"
       [class.disabled]="!VCPdfViewer?.isDirty && !isNew "
       [tooltip]="getGlobal('Save')"
       flow="left">
    </i>
    <i class="fal fa-pencil search-filter-action"
       (click)="openModalFormularVersionComponent(frmVData)"
       [class.disabled]="isNew"
       [tooltip]="getGlobal('Edit')"
       flow="left">
    </i>
    <i class="fal fa-file-signature search-filter-action"
       (click)="openSignatureModal()"
       [class.disabled]="isNew"
       [tooltip]="'Unterschreiben'"
       flow="left">
    </i>
  </div>
</div>
